import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const AboutSection = () => {
  const { language } = useLanguage();

  const content = {
    es: {
      title: 'Carolina Riestra',
      subtitle: 'Directora Creativa',
      bio: [
        'Carolina Riestra es una diseñadora de interiores con más de una década de experiencia creando espacios que combinan elegancia, sensibilidad artística y un entendimiento profundo por cómo los espacios influyen en la vida y las emociones.',
        'Formada en México e Italia en Diseño e Interiorismo, su trayectoria evoluciona desde el mundo de la moda hasta la arquitectura, integrando una visión estética global con una metodología meticulosa y un sello femenino inconfundible.',
        'Como Directora Creativa de CR Home, Caro se ha especializado en proyectos integrales de alto nivel para clientes high-end y desarrolladores luxury que buscan una transformación completa, más allá de la simple decoración. Su enfoque se centra en diseñar espacios con alma: ambientes donde la belleza, la armonía y la funcionalidad conviven de manera orgánica para elevar la experiencia diaria de quienes los habitan.',
        'Su misión es clara: embellecer los entornos personales para que generen plenitud, inspiración y disfrute, creando un impacto positivo en la vida de cada persona.',
        'Con un estilo cálido, contemporáneo y profundamente humano, Caro convierte cada proyecto en una obra que trasciende lo visual—un espacio que se siente, se vive y permanece.'
      ]
    },
    en: {
      title: 'Carolina Riestra',
      subtitle: 'Creative Director',
      bio: [
        'Carolina Riestra is an interior designer with over a decade of experience creating spaces that combine elegance, artistic sensitivity, and a deep understanding of how spaces influence life and emotions.',
        'Trained in Mexico and Italy in Design and Interior Design, her career has evolved from the world of fashion to architecture, integrating a global aesthetic vision with meticulous methodology and an unmistakable feminine signature.',
        'As Creative Director of CR Home, Caro has specialized in comprehensive high-level projects for high-end clients and luxury developers seeking complete transformation, beyond simple decoration. Her approach focuses on designing spaces with soul: environments where beauty, harmony, and functionality coexist organically to elevate the daily experience of those who inhabit them.',
        'Her mission is clear: to beautify personal environments so they generate fulfillment, inspiration, and enjoyment, creating a positive impact on each person\'s life.',
        'With a warm, contemporary, and deeply human style, Caro transforms each project into a work that transcends the visual—a space that is felt, lived, and endures.'
      ]
    }
  };

  const text = content[language];

  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Photo */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute inset-0 bg-amber-100/20 transform translate-x-6 translate-y-6 rounded-sm"></div>
              <img
                src="/images/carolina.webp"
                alt="Carolina Riestra"
                loading="lazy"
                className="relative w-full h-auto object-cover rounded-sm shadow-2xl"
              />
            </div>
          </div>

          {/* Bio */}
          <div className="order-1 lg:order-2 space-y-8">
            <div>
              <p className="text-amber-600 text-sm font-light tracking-[0.3em] uppercase mb-4">Designer</p>
              <h2 className="text-5xl md:text-6xl font-light text-neutral-900 mb-2 tracking-tight">
                {text.title}
              </h2>
              <p className="text-xl text-neutral-500 font-light italic">{text.subtitle}</p>
            </div>

            <div className="space-y-6">
              {text.bio.map((paragraph, index) => (
                <p key={index} className="text-neutral-600 leading-relaxed font-light">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;